import type { TCreateTripTaskReq } from 'api/swagger';
import { buildLocationPayload as buildLocation, validateLocationByMode } from 'shared/utils/address';
import { ETripTaskType } from 'types/trips';
import type { TAddressFields, TCoordinatesFields } from '../trip-create-task-modal/types';
import type { ELocationMode } from '../trip-create-task-modal/types';

export const validateTrailerSwapForm = (
  relatedTripId: number | undefined,
  locationMode: ELocationMode,
  coordinates: TCoordinatesFields,
  address: TAddressFields,
) => {
  const hasTripSelected = relatedTripId !== undefined;
  const hasLocation = validateLocationByMode(locationMode, coordinates, address);

  return hasTripSelected && hasLocation;
};

export const buildLocationPayload = (
  locationMode: ELocationMode,
  coordinates: TCoordinatesFields,
  address: TAddressFields,
): TCreateTripTaskReq => {
  return {
    type: ETripTaskType.trailer_swap,
    creationMode: 'one_task',
    ...buildLocation(locationMode, coordinates, address),
  };
};
